export const SET_SIGNATORIES = 'SET_SIGNATORIES';
export const RESET_SIGNATORIES = 'RESET_SIGNATORIES';
export const SET_SIGNATORY_SEARCH_PARAMS = 'SET_SIGNATORY_SEARCH_PARAMS';
